import React, { memo } from 'react';

import { Box, Typography } from '@mui/material';
import PendingChangesCard from 'app/pages/loanApplication/LoanHeaders/RedesignedLoanInfoHeader/PendingChangesDrawer/components/PendingChangesCard';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { STAGED_CHANGES_LABELS, StagedChangesTestIds } from './StepPendingCommitChanges.constants';
import {
  containerStyles,
  headingStyles,
  listStyles,
  messageStyles,
} from './StepPendingCommitChanges.styles';

// The confirmation is a review surface, not the loan editor, so a change card is
// read-only here — clicking must not navigate away from the AI Activity tab.
const noNavigate = _.noop;

const StagedChangesList = ({ changes, isLoading }) => {
  if (isLoading) {
    return (
      <Typography data-testid={StagedChangesTestIds.LOADING} sx={messageStyles} variant="regular12">
        {STAGED_CHANGES_LABELS.LOADING}
      </Typography>
    );
  }

  if (!changes.length) {
    return (
      <Typography data-testid={StagedChangesTestIds.EMPTY} sx={messageStyles} variant="regular12">
        {STAGED_CHANGES_LABELS.EMPTY}
      </Typography>
    );
  }

  return (
    <Box data-testid={StagedChangesTestIds.LIST} sx={containerStyles}>
      <Typography data-testid={StagedChangesTestIds.HEADING} sx={headingStyles} variant="regular12">
        {STAGED_CHANGES_LABELS.HEADING({ count: changes.length })}
      </Typography>
      <Box sx={listStyles}>
        {changes.map(change => (
          <PendingChangesCard
            change={change}
            key={change.id ?? `${change.entityPrimaryKey}-${change.propertyName}`}
            onNavigate={noNavigate}
          />
        ))}
      </Box>
    </Box>
  );
};

StagedChangesList.propTypes = {
  changes: PropTypes.arrayOf(PropTypes.object).isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default memo(StagedChangesList);
